import { convertToUTCDateTime } from "./utils";
import type { FormValues } from "./validation/schema";
import type { EventSessionUpdatedEmailPreviewInput } from "../_queries/emailPreviewQueries";

export type SessionPreviewCandidate = EventSessionUpdatedEmailPreviewInput & {
  label: string;
};

function sessionEndDate(session: FormValues["sessions"][number]) {
  return session.date.endDate || session.date.startDate;
}

export function getSessionPreviewCandidates(
  initialSessions: FormValues["sessions"] = [],
  currentSessions: FormValues["sessions"] = [],
  timezone: string
): SessionPreviewCandidate[] {
  const candidates: SessionPreviewCandidate[] = [];

  for (const current of currentSessions) {
    if (!current.id) {
      continue;
    }

    const initial = initialSessions.find((session) => session.id === current.id);
    if (!initial) {
      continue;
    }

    const oldStartsAt = convertToUTCDateTime(initial.date.startDate, initial.startTime, timezone);
    const newStartsAt = convertToUTCDateTime(current.date.startDate, current.startTime, timezone);
    const oldEndsAt = convertToUTCDateTime(sessionEndDate(initial), initial.endTime, timezone);
    const newEndsAt = convertToUTCDateTime(sessionEndDate(current), current.endTime, timezone);

    const startChanged = Boolean(oldStartsAt && newStartsAt && oldStartsAt !== newStartsAt);
    const endChanged = Boolean(oldEndsAt && newEndsAt && oldEndsAt !== newEndsAt);

    if (!startChanged && !endChanged) {
      continue;
    }

    if (!oldStartsAt) {
      continue;
    }

    const input: EventSessionUpdatedEmailPreviewInput = {
      sessionId: current.id,
      oldStartsAt
    };

    if (startChanged) {
      input.newStartsAt = newStartsAt;
    }

    if (endChanged) {
      input.newEndsAt = newEndsAt;
    }

    const labelParts = [current.date.startDate];
    if (current.startTime) {
      labelParts.push(current.startTime);
    }

    candidates.push({
      ...input,
      label: labelParts.join(" · ")
    });
  }

  return candidates;
}
